import React from "react";
import { View, Text } from "@react-pdf/renderer";
import { reportStyles } from "./styles";

export const ReportTable = ({
  headers,
  rows,
  compact = false,
  cellWidths,
  cellStyles = {},
}) => {
  const tableStyle = compact ? reportStyles.tableCompact : reportStyles.table;
  const rowStyle = compact ? reportStyles.tableRowCompact : reportStyles.tableRow;
  const cellStyle = compact
    ? reportStyles.tableCellCompact
    : reportStyles.tableCell;

  const getCellWidth = (index) => {
    if (cellWidths && cellWidths[index] !== undefined) {
      return { width: cellWidths[index] };
    }
    if (headers && headers.length > 0) {
      return { width: `${100 / headers.length}%` };
    }
    return {};
  };

  return (
    <View style={tableStyle}>
      <View style={[rowStyle, reportStyles.tableHeader]}>
        {headers.map((header, i) => (
          <Text
            key={i}
            style={[
              cellStyle,
              { fontWeight: "bold", fontSize: compact ? 9 : 10 },
              getCellWidth(i),
              cellStyles.header?.[i],
            ]}
          >
            {header}
          </Text>
        ))}
      </View>
      {rows.map((row, rowIndex) => (
        <View
          key={rowIndex}
          style={[
            rowStyle,
            row.rowStyle,
            row.backgroundColor && { backgroundColor: row.backgroundColor },
          ]}
        >
          {row.cells.map((cell, cellIndex) => (
            <Text
              key={cellIndex}
              style={[
                cellStyle,
                getCellWidth(cellIndex),
                cellStyles.cell?.[cellIndex],
                row.cellStyles?.[cellIndex],
                cell.bold && { fontWeight: "bold" },
              ]}
            >
              {cell.value}
            </Text>
          ))}
        </View>
      ))}
    </View>
  );
};
